const $ = require('jquery');
const angular = require('angular');
const atmLinkClickMapper = require('./atmmapper/bws-bot-link-click-mapper');
module.exports = function (
  $interval,
  $window,
  CurrentUserService,
  settingsService,
  $rootScope,
  shopPageStateService,
  $location,
  $uibModal,
  storePickerService,
  atm,
  BwsBotService
) {
  return {
    restrict: 'E',
    scope: {},
    link(scope) {
      scope.shopPageStateService = shopPageStateService.panels.right;
      scope.currentUser = CurrentUserService.currentUser;
      scope.$uibModal = $uibModal;
      scope.storePickerService = storePickerService;
      scope.searchStoreId;
      scope.searchStoreName;
      scope.prodDetailsUrl;

      let showWidget = false;

      const showBWSPopup = false;
      const windowSize = {
        height: 0,
        width: 0,
      };
      let isMobile = false;
      let modalInstance = null;
      const uat = 'https://aueuatstorbwsbot.z8.web.core.windows.net/';
      const domainuat = 'https://botwidget.uat.bws.com.au/';
      const domainprod = 'https://botwidget.bws.com.au/';
      const prod = 'https://aueprodstorbwsbot.z8.web.core.windows.net/';
      const local = '';
      let widgetUrl = '';
      let source = '';
      const context = '';
      const data = '';
      let frame = '';
      scope.firstTime = true;
      let intervalPromise = null;
      let botLoadingInterval = null;
      let isScrolling = false;
      let scrollTimeout;
      let scrollNotifiyTimeout;

      //To hide the BOT settings from traders
      function selectWidgetUrl() {
        switch (source) {
          case 'uat':
            widgetUrl = uat;
            break;
          case 'domainuat':
            widgetUrl = domainuat;
            break;
          case 'domainprod':
            widgetUrl = domainprod;
            break;
          case 'prod':
            widgetUrl = prod;
            break;
          default:
            widgetUrl = local;
            break;
        }
      }
      scope.$on('$destroy', function () {
        $interval.cancel(intervalPromise);
      });

      settingsService.frontEndSettings =
        settingsService.frontEndSettings.filter(
          (setting) => setting.Name !== 'botsitesettings'
        );
      settingsService
        .getFrontendSetting('botsetting', 'botsitesettings')
        .then((res) => {
          scope.settingsforbot = JSON.parse(res[0].Value);
          if (scope.settingsforbot.IsBotEnabled) {
            source = scope.settingsforbot.Source;

            //To check if user login or logout
            $rootScope.$on('login:success', function () {
              changeShopperId();
            });
            $rootScope.$on('logout:start', function () {
              changeShopperId();
            });

            intervalPromise = $interval(() => {
              const divElement =
                document.getElementsByClassName('bwsbot_root')[0];
              const rightPanelWidth = $('#right-panel').width();
              if (rightPanelWidth === 0 || rightPanelWidth === null) {
                divElement.style.right = '0px';
              } else {
                const widthAdjustment = rightPanelWidth + 24;
                divElement.style.right = widthAdjustment + 'px';
              }
            }, 100);

            $(document).on(
              'click',
              '.pull-right.icon--plus.icon--remove',
              function () {
                const divElement =
                  document.getElementsByClassName('bwsbot_root')[0];
                divElement.style.bottom = '0px';
              }
            );

            function IsBannerOpen() {
              const divElement =
                document.getElementsByClassName('bwsbot_root')[0];

              const bannerElement = document.getElementById('branch-banner-iframe');

              if (bannerElement && bannerElement.style.bottom === '0px') {
                const newHeight = bannerElement.offsetHeight + 24;
                divElement.style.bottom = newHeight + 'px';
                return;
              }

              const change_botPosition = botPosition();
              let botPositionFromBottom = 0;
              let currentUrl_pathname = '';
              //If change_botPosition true, move the bot 50px from the bottom.
              if (change_botPosition) {
                if ($location.path().split('/')[1]) {
                  currentUrl_pathname = $location.path().split('/')[1];
                }
                if (currentUrl_pathname == 'product') {
                  if ($('.ins-cloned-container-c154').hasClass('ins-display-none-c154')) {
                    botPositionFromBottom = 0;
                  } else {
                    botPositionFromBottom = 180;
                  }
                }
                else {
                  botPositionFromBottom = 50;
                }
              }
              let current_botPosition = 0;
              if ($('.skewed').length > 0) {
                if ($('.feature-promo--container_hide').length > 0) {
                  divElement.style.bottom = botPositionFromBottom + current_botPosition + 'px';
                } else {
                  current_botPosition = 50;
                  divElement.style.bottom = botPositionFromBottom + current_botPosition + 'px';
                }
              } else {
                divElement.style.bottom = botPositionFromBottom + current_botPosition + 'px';
              }
            }

            selectWidgetUrl();
            function attachBWSBot() {
              botPosition();
              const iframe = document.createElement('iframe');
              iframe.src =
                widgetUrl + '?' + Math.floor(Math.random() * 10000) + 1;
              iframe.id = 'ed_bwsbotframe';
              iframe.style.border = '0';
              iframe.style.height = '100%';
              iframe.style.width = '100%';
              iframe.title = 'BWS Chatbot';
              const divElement =
                document.getElementsByClassName('bwsbot_root')[0];
              divElement.appendChild(iframe);
              frame = document.getElementById('ed_bwsbotframe');
              frame = frame ? frame.contentWindow : null;
            }
            function sendCallToBWS(objCall) {
              const dataObj = JSON.stringify(objCall);
              selectWidgetUrl();
              frame.postMessage(dataObj, widgetUrl);
            }
            function setIsHostDevice() {
              const objCall = {
                data: {
                  setIsHostDevice: isMobile,
                },
                methodHandler: 'setIsHostDevice',
              };
              sendCallToBWS(objCall);
            }
            function changeShopperId() {
              const objCall = {
                data: {
                  shopperId: scope.currentUser.id,
                  encryptedShopperId: scope.currentUser.encryptedShopperId
                },
                methodHandler: 'changeShopperId',
              };
              sendCallToBWS(objCall);
            }
            function notifyBotAboutScrolling(isScrolling, methodHandler) {
              clearTimeout(scrollNotifiyTimeout);
              scrollNotifiyTimeout = setTimeout(() => {
                sendCallToBWS({
                  data: { isScrolling: isScrolling },
                  methodHandler: methodHandler,
                });
              }, 200);
            }

            angular.element($window).on('scroll', function () {
              if (!isMobile || (isMobile && showWidget)) {
                return;
              }

              if (!isScrolling) {
                isScrolling = true;
                notifyBotAboutScrolling(isScrolling, 'bwsSiteScrollStart');
              }

              clearTimeout(scrollTimeout);

              scrollTimeout = setTimeout(() => {
                isScrolling = false;
                notifyBotAboutScrolling(isScrolling, 'bwsSiteScrollEnd');
                scope.$apply();
              }, 200);
            });

            function isMobileView() {
              if (window.innerWidth > 768 && window.innerHeight > 650) {
                return false
              } else {
                return true;
              }
            }

            window.addEventListener('load', () => {
              attachBWSBot();
              isMobile = isMobileView();
              setTimeout(() => {
                LoadBot();
              }, 500);
            });

            function LoadBot() {
              botLoadingInterval = $interval(() => {
                changeShopperId();
                setIsHostDevice();
                IsBannerOpen();
                checkOutBotVisibility();
              }, 500);
            }

            function ClearBotInterval() {
              $interval.cancel(botLoadingInterval);
            }


            window.addEventListener('resize', (e) => {
              isMobile = isMobileView();
              setIsHostDevice();
              resizeWindow();
            });

            function resizeWindow() {
              const divElement =
                document.getElementsByClassName('bwsbot_root')[0];
              if (isMobile) {
                if (showWidget) {
                  divElement.style.height = '100%';
                  divElement.style.width = '100%';
                  divElement.style.bottom = '0px';
                } else {
                  divElement.style.height = '86px';
                  if (showBWSPopup) {
                    divElement.style.width = '265px';
                  } else {
                    divElement.style.width = '75px';
                  }
                }
              } else {
                if (showWidget) {
                  divElement.style.height = '580px';
                  divElement.style.width = '400px';
                  divElement.style.bottom = '0px';
                } else {
                  divElement.style.height = '86px';
                  if (showBWSPopup) {
                    divElement.style.width = '300px';
                  } else {
                    divElement.style.width = '125px';
                    divElement.style.bottom = '0px';
                  }
                }
              }
            }


            // change bot position depending upon current url.
            function botPosition() {
              const currentUrl_pathname = $location.path().split('/')[1];
              if (isMobile) {
                if (!showWidget) {
                  if (scope.settingsforbot.PagesWithStickyButtons.indexOf(currentUrl_pathname) >= 0) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              }
            }

            // conditinally render bot based on botSetting from Trader
            function checkOutBotVisibility() {
              if (scope.settingsforbot.BlockedPaths) {
                const url_pathname = ($location.path() === '/' ? '' : $location.path().split('/')[1].trim());
                const blockedPaths = scope.settingsforbot.BlockedPaths.split(',');
                const blockedPathsObject = {};

                blockedPaths.forEach(blockpath => {
                  const trimmedBlockpath = blockpath.trim();
                  blockedPathsObject[trimmedBlockpath] = true;
                });

                const isMobileView = $window.innerWidth <= 768;
                const bwsroot_r = document.getElementsByClassName('bwsbot_root')[0];

                const isBlocked = blockedPathsObject.hasOwnProperty("/" + url_pathname);

                if (isBlocked && isMobileView && bwsroot_r) {
                  bwsroot_r.style.display = 'none';
                } else {
                  bwsroot_r.style.display = 'block';
                }
              }
            }

            window.addEventListener('message', (e) => {
              const eventData = e.data;
              try {
                const params = typeof eventData === 'string' ? JSON.parse(eventData) : eventData;
                switch (params.methodHandler) {
                  case 'toggleWidget':
                    showWidget = params.data.showWidget;
                    resizeWindow();
                    setIsHostDevice();
                    if (scope.firstTime) {
                      changeShopperId();
                      scope.firstTime = false;
                    }
                    IsBannerOpen();
                    ClearBotInterval();
                    break;
                  case 'launchMedallia':
                    break;
                  case 'isLCAvailable':
                    window.top.postMessage(
                      { isLCAvailable: params.data.isLCAvailable },
                      '*'
                    );
                    break;
                  case 'chatbotInitChangeUrl':
                    // if there is no prod details url, return
                    if (params.data.prodDetailsUrl === '') {
                      return;
                    }
                    else if (params.data.prodDetailsUrl === '/secure-login') {
                      $location.path(params.data.prodDetailsUrl);
                    }
                    else {
                      scope.prodDetailsUrl = params.data.prodDetailsUrl;
                      const clickAndCollectDetails = storePickerService.fulfilmentInfo.ClickAndCollectDetails;
                      scope.searchStoreId = params.data.storeId;
                      scope.searchStoreName = params.data.storeName;

                      if (clickAndCollectDetails !== null) {
                        if (String(storePickerService.fulfilmentMethod).toLowerCase() !== 'pick up' || params.data.storeId !== clickAndCollectDetails.FulfilmentStoreID) {
                          // the the store selected is not the same as the store saved in the users shopping mission
                          // show modal
                          modalInstance = scope.$uibModal.open({
                            animation: true,
                            templateUrl: 'confirm-store-change',
                            scope,
                            size: 'md',
                            backdrop: 'static',
                            windowClass: 'modal--stock-nearby'
                          });
                        } else {
                          // if the stores are the same just redirect to the PDP page
                          $location.path(scope.prodDetailsUrl.replace(/DM_/g, ''));
                        }
                      } else {
                        // if the clickAndCollectDetails object is null, change the store immediately
                        scope.changeStore(params.data.storeId, scope.prodDetailsUrl.replace(/DM_/g, ''));
                      }
                    }
                    break;
                  case 'chatbotTriggerAdobeAnalytics':
                    atm.push(params.data, atmLinkClickMapper);
                    break;
                  default:
                    break;
                }

                if (params.name === 'chatbotQRClicked') {
                  const paramsText = params.text && params.text.toLowerCase() || '';
                  let data;

                  switch (paramsText) {
                    case 'view related faqs':
                      data = { cta: paramsText, text: '' };
                      break;
                    case 'log in':
                      data = { cta: 'login', text: 'track my deliveries' };
                      break;
                    case `i don't have an account`:
                      data = { cta: paramsText, text: 'track my deliveries' };
                      break;
                    default:
                      break;
                  }
                  data && atm.push(data, atmLinkClickMapper);
                }
              } catch (error) {
                // Handle the error if the event data is not valid JSON (e.g., if it's just a plain string)
                console.error('Error parsing event data:', error);
              }
            });
          } else {
            const bwsroot = document.getElementsByClassName('bwsbot_root')[0];
            bwsroot.style.display = 'none';
          }
        });

      scope.closePopup = () => {
        modalInstance.dismiss('cancel');
        $location.path(scope.prodDetailsUrl.replace(/DM_/g, ''));
      };

      scope.updatePreference = () => {
        scope.changeStore(scope.searchStoreId, scope.prodDetailsUrl.replace(/DM_/g, ''));
      };

      scope.changeStore = (storeNumber, path) => {
        storePickerService.setPickupByStoreNo(storeNumber).then(() => {
          if (modalInstance !== null) modalInstance.dismiss('cancel');
          $location.path(path);
        });
      };
      function chatWithBWSBot() {
        const iframe = document.getElementById('ed_bwsbotframe');
        if (iframe) {
          const objCall = {
            data: {
              showWidget: showWidget,
            },
            methodHandler: "openWidget",
          };
          iframe.contentWindow.postMessage(objCall, widgetUrl)
        }
      }

      window.chatWithBWSBot = scope.chatWithBWSBot;
      BwsBotService.chatWithBot = chatWithBWSBot;

      module.exports = {
        chatWithBWSBot
      }
    },
    template: require('./bws-bot-template.html'),
  };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/bwsbot/bws-bot-directive.js
 **/